"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendSMSRegist = exports.substitutes = void 0;
const lodash_1 = __importDefault(require("lodash"));
const throttle_1 = __importDefault(require("lodash/throttle"));
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_query_1 = require("react-query");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importDefault(require("styled-components"));
const Colors_1 = require("../../../../Colors");
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const sms_1 = require("../../../../server/sms");
const DeletePopUpLayout_1 = require("../../../base/layout/DeletePopUpLayout");
const popup_1 = require("../../../base/popup");
const action_1 = require("../../../menu/action");
const constant_1 = require("../constant");
const layout_1 = require("../../../base/layout");
const MemberList_1 = require("./MemberList");
const react_quill_1 = require("react-quill");
const SendSMSContentStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	flex: 1;
	position: relative;
	gap: ${props => (props.$isDesktop ? '40px' : '12px')};
	overflow: auto;

	.divider {
		background: var(--color-grey-c, #e6e8ed);
		align-self: stretch;
		flex-shrink: 0;
		height: 1px;
	}

	.sms-preview {
		display: flex;
		flex-direction: column;
		padding: 26px;
		width: 25%;
		height: 100%;
		border-radius: 10px;
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		border-width: 1px;
		min-width: 260px;
		overflow: auto;
	}

	.sms-preview-content {
		word-break: break-word;	
		flex: 1;
		width: 100%;	
    	min-height: 100px;
	    border-radius: 4px;
    	border-style: solid;
    	border-color: var(--color-grey-w, #b6bac0);
    	border-width: 1px;
	    white-space: pre-wrap;
		padding: 9px;
    	text-align: left;
    	font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
    	font-size: var(--b4-font-size, 14px);
    	line-height: 150%;
    	font-weight: var(--b4-font-weight, 400);
		span {
			text-align: left;
    		font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
    		font-size: var(--b4-font-size, 14px);
    		line-height: 150%;
    		font-weight: var(--b4-font-weight, 400);
		}
	}

	.sms-regist {
		${props => (props.$isDesktop ? `
			display: flex;
			flex-direction: column;
			padding: 26px;	
			gap: 24px;
			width: 75%;
			height: 100%;
			border-radius: 10px;
			border-style: solid;
			border-color: var(--color-grey-c, #e6e8ed);
			border-width: 1px;
			overflow: auto;
			` : `
			display: flex;
			flex-direction: column;
			gap: 12px;
			width: 100%;
			height: 100%;
			overflow-y: auto;
			`)}
	}

	.sms-setting-content {
		${props => (props.$isMobile && "height: 100%;")}
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.sms-setting {
		display: flex;
		flex-direction: ${props => (!props.$isMobile ? 'row' : 'column')};
		gap: ${props => (props.$isDesktop ? '32px' : '12px')};
		height: ${props => (props.$isDesktop ? '40px' : 'fit-content')};
		align-items: ${props => (!props.$isMobile ? 'center' : 'flex-start')};
		${props => (props.$isTablet && `
			flex-direction: column;
			height: fit-content;
			gap: 4px;
			align-items: flex-start;	
		`)}
	}

	.sms-substitute-wrap {
		display: flex;
		flex-direction: ${props => (!props.$isMobile ? 'row' : 'column')};
		gap: 12px;
		flex-shrink: 0;
		align-items: ${props => (!props.$isMobile ? 'center' : 'flex-start')};
	}

	.sms-type {
		display: flex;
		flex-direction: row;
		gap: 12px;
		flex-shrink: 0;
		align-items: center;
		min-height: ${props => (!props.$isMobile ? '45px' : 'fit-content')};
	}

	.sms-time-wrap {
		display: flex;
		flex-direction: row;
		gap: 44px;
		flex-shrink: 0;
		align-items: center;
	}

	.sms-time {
		display: flex;
		flex-direction: row;
		gap: 12px;
		align-items: center;

		input {
    		border-radius: 4px;
    		border-style: solid;
    		border-color: var(--color-grey-w, #b6bac0) !important;
    		border-width: 1px;
    		padding: ${props => (!props.$isMobile ? '7px' : '5px')};
    		width: ${props => (!props.$isMobile ? '118px' : '116px')};
			${props => (props.$isMobile && 'height: 32px;')}
    		box-sizing: border-box;
    		color: var(--color-black, #101010);
    		text-align: left;
    		font-family: var(--b4-font-family, "Noto Sans KR", sans-serif);
		    font-size: var(--b4-font-size, 14px);
    		line-height: var(--b4-line-height, 22px);
		    letter-spacing: var(--b4-letter-spacing, -0.02em);
    		font-weight: var(--b4-font-weight, 400);
    		position: relative;
    		text-overflow: ellipsis;
    		overflow: hidden;
    		white-space: nowrap;
    		appearance: none;
    		-webkit-appearance: none;
    		-moz-appearance: none;
		}

		${props => (props.$isTablet && `
			height: 40px;
		`)}
	}

	.substitute-list {
		display: flex;
		flex-direction: row;
		gap: 12px;
		flex-wrap: wrap;
	}
	
	.icon-wrap {
		width: 122px;
		height: 122px;
		border: solid 1px ${Colors_1.Colors.w_grey};
		border-radius: 100%;
	}

	.select-sms {
		font-size: 30px;
		font-weight: 700;
		line-height: 36px;
		letter-spacing: -0.02em;
		color: #7691B6;
	}

	.btn-recipient-setting {
		background: var(--color-white, #ffffff);
		border-radius: 100px;
		border-style: solid;
		border-color: var(--tur, #3ab2bf);
		border-width: 1px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;

		p {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			${props => !props.$isDesktop
    ? `
				font-size: 12px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
			`
    : `
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				letter-spacing: var(--b4-letter-spacing, -0.02em);
				font-weight: var(--b4-font-weight, 400);`}
			padding-bottom: 3px;
			position: relative;
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}

		${props => !props.$isMobile
    ? `
					position: absolute;
					right: 24px;
					padding: 4px 18px 4px 18px;
					z-index: 1;	
					gap: 8px;
				`
    : `  
					padding: 4px 10px 4px 10px;
					gap: 0px;
				`}
	}

	span,
	.overText {
		flex-shrink: 0;
		position: relative;
		text-align: left;

		${props => props.$isDesktop
    ? `
					font-size: var(--b3-font-size, 16px);
					line-height: var(--b3-line-height, 32px);
					letter-spacing: var(--b3-letter-spacing, -0.02em);
					font-weight: var(--b3-font-weight, 400);
				  `
    : `
					font-size: 14px;
					line-height: 150%;
					letter-spacing: -0.02em;
					font-weight: 400;
				  `}
	}

	.sms-wrap {
		display: flex;
		width: 100%;
		height: 100%;
		flex-direction: row;
		flex: 1;
		gap: ${props => (!props.$isMobile ? '32px' : '20px')};
		padding: ${props => (props.$isDesktop ? '0px' : '20px')};
		overflow: auto;
	}

	.preview-wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: ${props => (!props.$isMobile ? '12px' : '10px')};
	}

	.send-wrap {
		min-height: ${props => (!props.$isMobile ? '40px' : '70px')};
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: ${props => (!props.$isMobile ? '12px' : '10px')};
		align-items: flex-start;
	}

	textarea {
		&.focus {
			outline: 2px solid transparent;
			outline-offset: 2px;
			box-shadow: 0 0 5px $tur; // 흐림 효과 추가
		}

		border-radius: 4px;
		border-style: solid;
		border-color: var(--color-grey-w, #b6bac0);
		border-width: 1px;
		width: 100%;
		resize: none;
		overflow: hidden;
		padding: 9px;

		color: var(--color-black, #101010);
		text-align: left;
		font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: 150%;
		font-weight: var(--b4-font-weight, 400);
	}

	.sms-title {
		max-height: 40px;
		min-height: 40px !important;
	}

	.sms-content-wrap {
		display: flex;
		width: 100%;
		flex: 1;
		height: 158px;
	}
	
	.editable {
		min-height: 100px;
		flex: 1;
	}

	// .sms-content {
	// 	min-height: 100px;
	// 	${props => props.$isMobile && 'height: 100% !important;'}
	// 	flex: 1;
	// }

	.sms-content {
		border-radius: 4px;
    	border-style: solid;
    	border-color: var(--color-grey-w, #b6bac0);
    	border-width: 1px;
    	resize: none;
    	overflow: hidden;
    	padding: 9px;
    	color: var(--color-black, #101010);
    	text-align: left;
    	font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
    	font-size: var(--b4-font-size, 14px);
    	line-height: 150%;
    	font-weight: var(--b4-font-weight, 400);
 	 	display: block;
  		min-height: 100px; 
		flex: 1;
  		white-space: pre-wrap;
		${props => props.$isMobile && 'height: 100% !important;'}
	}

	.ql-editor::before {
    	font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
    	font-size: var(--b4-font-size, 14px);
    	color: gray;
    	font-style: normal;
		left: 0px;
	}

	.ql-editor * {
		font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
		font-size: var(--b4-font-size, 14px);
		line-height: 150%;
		font-weight: var(--b4-font-weight, 400);
		color: var(--color-black, #101010);
	}

	.content-info {
		display: flex;
		flex-direction: row;
		align-items: center;
		text-align: center;
		gap: 6px;
	}

	.substitute-empty {
		height: 36px;
		width: 100%;
		line-height: 115%;
	}

	.substitute-word {
		height: 36px;
    	width: fit-content;
    	padding: 0;
    	border-color: ${Colors_1.Colors.dark_tur};
		color: ${Colors_1.Colors.light_tur};
		background-color: #F5F9F9;
    	align-content: center;
    	text-align: center;
		border-radius: 6px;
		cursor: pointer;

		.overText {
			min-width: 0px;
		}
	}

	.open-member-list {
		display: flex;
		flex-direction: column;
		height: fit-content;
		width: 100%;
	}

	.xmd {
		p {
			font-size: 14px;
			line-height: 20px;
			display: flex;
			justify-content: center;
		}
	}

	.message-text {
		align-content: center;
		flex-shrink: 0;
		min-height: ${props => (props.$isDesktop ? '32px' : props.$isTablet ? '25px' : '20px')};
	}

	.message-length {
		align-content: center;
		text-align: right;
		font-size: 16px;
		line-height: 32px;
		color: var(--color-grey-b, #7e8289);
	}

	.btn-container {
		margin: 0;
	}

	.send-type {
		span {
			font-size: ${props => (props.$isDesktop ? '14px' : '12px')};
		}
	}

	${props => props.$isMobile &&
    `
			.mobile-full {
				border-radius: 6px;
				p {
					justify-content: center;
				}
			}

			.btn-container {
				width: 100%;
			}
		`}

	.member-list-popup{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}

	.popup-body {
		gap: 16px;
	}

	.popup-header-member-list {
		padding-bottom: 12px;
    	width: 100%;
    	display: flex;
    	justify-content: space-between;
    	align-items: center;
    	box-sizing: border-box;

		border-bottom: 1px solid #e6e8ed;

		.overText {
			font-size: 16px;
			line-height: 24px;
			font-weight: 700;
		}
	}
	
	.popup-content {
		overflow-x: hidden;
		overflow-y: auto;
	}
`;
exports.substitutes = [
    '이름',
    '번호',
    '항목1',
    '항목2',
    '항목3',
    '항목4'
];
exports.SendSMSRegist = react_1.default.memo(({ selectedId = "", }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [isNormal, setIsNormal] = react_1.default.useState(true); //발송유형(일반/치환) checkBox
    const [isImmediately, setIsImmediately] = react_1.default.useState(true); //발송일자 checkBox
    const [isFixNumber, setIsFixNumber] = react_1.default.useState(true); //발신번호 checkBox
    const [startDate, setStartDate] = (0, react_1.useState)(''); // 발송일
    const [startTime, setStartTime] = (0, react_1.useState)(''); // 발송시간
    const [directNumber, setDirectNumber] = (0, react_1.useState)(''); // 발신번호
    const [title, setTitle] = (0, react_1.useState)(''); // 메시지 제목
    const [message, setMessage] = (0, react_1.useState)(''); // 발송 메시지
    const [defaultMessage, setDefaultMessage] = (0, react_1.useState)(''); // 발송 메시지(수정할 때 default 값)
    const [preview, setPreview] = (0, react_1.useState)(''); // 미리보기 메시지
    const [openMemberList, setOpenMemberList] = (0, react_1.useState)(false); // 수신자 리스트 팝업
    const [receiverMemberList, setReceiverMemberList] = (0, react_1.useState)([]); // 수신자 리스트
    const [memberSetting, setMemberSetting] = react_1.default.useState('everyStudent'); //수신자 설정(수강생전체/한 건씩 추가/엑셀 업로드) checkBox
    const [originalStudentData, setOriginalStudentData] = (0, react_1.useState)([]); // 수강생(전체) 원본 데이터터
    const [everyStudentData, setEveryStudentData] = (0, react_1.useState)([]); // 수강생(전체) 데이터
    const [oneByOneData, setOneByOneData] = (0, react_1.useState)([]); // 한 건씩 추가 데이터
    const [excelUploadData, setExcelUploadData] = (0, react_1.useState)([]); // 엑셀 업로드 데이터
    const [isOnlyStudentMember, setIsOnlyStudentMember] = (0, react_1.useState)(true); // 학생에게만 보내기
    const previewDivRef = react_1.default.useRef(null); // Use ref to reference the div
    // 한글 2바이트, 영문 1바이트로 계산
    const getCoolsmsByteLength = (message) => [...message].reduce((bytes, char) => bytes + (char.charCodeAt(0) <= 127 ? 1 : 2), 0);
    const messageBytes = getCoolsmsByteLength(message);
    const isSMSLength = messageBytes <= 90;
    const messageLength = isSMSLength ? `(${messageBytes}/90)` : "MMS";
    // 현재 시간
    const now = (0, react_1.useMemo)(() => (0, moment_1.default)(), []);
    const registSendSMSMutation = (0, react_query_1.useMutation)(sms_1.postRegistSendSMS);
    const modifySendSMSMutation = (0, react_query_1.useMutation)(sms_1.postModifySendSMS);
    const { data, refetch } = (0, sms_1.useSendSMSList)({
        id: selectedId,
    });
    const { data: receiversData, refetch: receiversRefetch } = (0, sms_1.useSMSReceiversList)({
        id: selectedId,
    });
    const refetchList = (0, throttle_1.default)(() => refetch(), 1000, { leading: true, trailing: false });
    const refetchReceiversList = (0, throttle_1.default)(() => receiversRefetch(), 1000, { leading: true, trailing: false });
    const cleanup = () => {
        setIsImmediately(true);
        setStartDate((0, moment_1.default)().format('YYYY-MM-DD'));
        setStartTime((0, moment_1.default)().format('HH:mm'));
        setIsFixNumber(true);
        setDirectNumber('');
        setTitle('');
        setMessage('');
        setPreview('');
        setReceiverMemberList([]);
        setIsOnlyStudentMember(true);
    };
    (0, react_1.useEffect)(() => {
        if (selectedId) {
            refetchList();
            refetchReceiversList();
        }
        else
            cleanup();
    }, [selectedId]);
    (0, react_1.useEffect)(() => {
        if (data) {
            const { items } = data;
            if (items && items.length >= 1) {
                const item = items[0];
                setIsImmediately(item.send_time === '' ? true : false);
                setStartDate((0, moment_1.default)(item.send_time).format('YYYY-MM-DD'));
                setStartTime((0, moment_1.default)(item.send_time).format('HH:mm'));
                setIsFixNumber(item.phone_number.includes('*') ? true : false);
                setDirectNumber(item.phone_number.includes('*') ? '' : item.phone_number);
                setTitle(item.title);
                setMessage(item.content);
                setDefaultMessage(item.content);
                setIsNormal(item.type === 'normal' ? true : false);
                setIsOnlyStudentMember(item.members_only !== false);
                const newReceiverMemberList = !lodash_1.default.isEqual(receiverMemberList, item.receivers) &&
                    receiverMemberList.length !== 0
                    ? receiverMemberList
                    : item.receivers;
                // @ts-ignore
                setReceiverMemberList(isMobile ? newReceiverMemberList : item.receivers);
                return;
            }
        }
        !isMobile && cleanup();
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (receiversData) {
            const { receivers, receivers_type } = receiversData;
            const memberSetting = receivers_type === 0 ? 'everyStudent' : 'oneByOne';
            setMemberSetting(memberSetting);
            if (receivers && receivers.length >= 1) {
                const simpleItems = receivers.map(receiver => ({
                    id: receiver[1],
                    data: receiver,
                }));
                setReceiverMemberList(simpleItems);
                if (memberSetting === 'everyStudent') {
                    setEveryStudentData(simpleItems);
                }
                else if (memberSetting === 'oneByOne') {
                    setOneByOneData(simpleItems);
                }
                else if (memberSetting === 'excelUpload') {
                    setExcelUploadData(simpleItems);
                }
            }
        }
    }, [receiversData]);
    // 치환문자 리스트의 너비를 동적으로 조절
    (0, react_1.useEffect)(() => {
        if (isNormal)
            return;
        if (exports.substitutes.length > 0) {
            exports.substitutes.forEach((item, index) => {
                const textarea = document.querySelectorAll(".substitute-word")[index];
                if (textarea) {
                    const context = document.createElement("canvas").getContext("2d");
                    if (context) {
                        context.font = getComputedStyle(textarea).font;
                        const textWidth = context.measureText(item).width;
                        textarea.style.width = `${textWidth + 20}px`;
                    }
                }
            });
        }
    }, [isNormal, exports.substitutes]);
    const handlerPreview = () => {
        const previewTitle = title.length > 0 ? `<span style="font-weight: bold;">${title}</span>\n` : '';
        setPreview(previewTitle + message);
    };
    (0, react_1.useEffect)(() => {
        if (isNormal)
            return;
    }, [message, exports.substitutes, isNormal]);
    // 미리보기에서 치환문자만 하이라이트
    (0, react_1.useEffect)(() => {
        if (isMobile)
            return;
        const previewDiv = previewDivRef.current;
        if (!previewDiv)
            return;
        if (!preview) {
            previewDiv.innerHTML = "<span style='color: gray;'>내용 없음</span>";
            return;
        }
        if (isNormal) {
            previewDiv.innerHTML = preview;
            return;
        }
        const highlightedText = preview.replace(/#\{(.*?)\}/g, (match, word) => {
            return exports.substitutes.includes(word)
                ? `<span style="color: #8268d9;">${match}</span>`
                : match;
        });
        previewDiv.innerHTML = highlightedText;
    }, [preview, exports.substitutes, isNormal, isMobile]);
    const extractSubstituteList = (message, substitutes) => {
        const matches = [...message.matchAll(/#\{(.*?)\}/g)].map(m => m[1]);
        return substitutes.filter(sub => matches.includes(sub));
    };
    const validateSubstitutes = (message, substitutes) => {
        const matches = [...message.matchAll(/#\{(.*?)\}/g)].map(m => m[1]);
        const hasInvalidWords = matches.some(word => !substitutes.includes(word));
        return !hasInvalidWords;
    };
    const handlerCancel = () => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: t(`supportRoom.answerPopUpcancel`),
                previosPage: () => {
                    if (isDesktop) {
                        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                            menuDetail: 'list',
                            id: undefined,
                        });
                    }
                    else {
                        dispatch((0, action_1.updateMenu)(undefined, { menu: 'sendSMS', detail: 'list' }));
                    }
                    APP.eventManager.publish(popup_1.TOGGLE_POPUP, null);
                },
            },
            width: 639,
            title: t(`common.menuMove`),
            isFit: true,
        });
    };
    const validatePhoneNumber = phoneNumber => {
        // 한국 전화번호 형식 검증: 010-1234-5678, 01012345678, 011-123-4567, 016-123-4567 등
        const phoneRegex = /^(01[016789]-?\d{3,4}-?\d{4}|070-\d{3,4}-\d{4}|0[2-9]{1}\d{1,2}-?\d{3,4}-?\d{4})$/;
        return phoneRegex.test(phoneNumber);
    };
    const closePopup = () => APP.eventManager.publish(popup_1.TOGGLE_POPUP, undefined);
    // (onClick) 보내기
    const handlerSend = async () => {
        const format = receiverMemberList.map(member => isNormal ? [
            member.data[0],
            member.data[1],
        ] : [
            member.data[0],
            member.data[1],
            member.data[2] || "",
            member.data[3] || "",
            member.data[4] || "",
            member.data[5] || ""
        ]);
        const extractList = extractSubstituteList(message, exports.substitutes);
        const isValidFormat = receiverMemberList.every(member => {
            const nickname = member.data[0];
            const phoneNumber = member.data[1];
            const hasMandatoryFields = nickname && phoneNumber;
            const hasAllSubstitutes = extractList.every(substitute => {
                if (substitute === "항목1")
                    return member.data[2] !== '-' && member.data[2]; // substitute1
                if (substitute === "항목2")
                    return member.data[3] !== '-' && member.data[3]; // substitute2
                if (substitute === "항목3")
                    return member.data[4] !== '-' && member.data[4]; // substitute3
                if (substitute === "항목4")
                    return member.data[5] !== '-' && member.data[5]; // substitute4
                return true;
            });
            return hasMandatoryFields && hasAllSubstitutes;
        });
        if (!isImmediately && (0, moment_1.default)(`${startDate} ${startTime}`).isBefore(now)) {
            return alert(t('sendSMS.retypeDate'));
        }
        if (receiverMemberList.length === 0) {
            return alert(t('sendSMS.selectMemberPlease'));
        }
        if (!isFixNumber && !validatePhoneNumber(directNumber)) {
            return alert(t('sendSMS.retypeNumber'));
        }
        if (!isSMSLength && title.length === 0) {
            return alert(t('sendSMS.noTitle'));
        }
        if (message.trim().length === 0) {
            return alert(t('sendSMS.retypeMessage'));
        }
        if (!isNormal && !validateSubstitutes(message, exports.substitutes)) {
            return alert(t('sendSMS.retypeSubstitute'));
        }
        if (!isNormal && !isValidFormat) {
            return alert(t('sendSMS.missingSubstitute'));
        }
        if (format.some(item => !item[1] || item[1].length < 10)) {
            return alert(t('sendSMS.zeroPhoneNumber'));
        }
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: selectedId ? t('sendSMS.editSMSPopUp') : t('sendSMS.submitSMSPopUp'),
                onRegist: handlerSubmit,
            },
            width: 639,
            title: selectedId ? t('sendSMS.editSMS') : t('sendSMS.submitSMS'),
            isFit: true,
        });
    };
    const handlerSubmit = async () => {
        const format = receiverMemberList.map(member => isNormal ? [
            member.data[0],
            member.data[1],
        ] : [
            member.data[0],
            member.data[1],
            member.data[2] || "",
            member.data[3] || "",
            member.data[4] || "",
            member.data[5] || ""
        ]);
        if (selectedId) {
            try {
                APP.eventManager.publish('SHOW_LOADING', true);
                const response = await modifySendSMSMutation.mutateAsync({
                    id: selectedId,
                    props: {
                        title: title,
                        content: message,
                        members_only: isOnlyStudentMember,
                        phone_number: isFixNumber ? '' : directNumber,
                        receivers: format,
                        receivers_type: memberSetting === 'everyStudent' ? 0 : memberSetting === 'oneByOne' ? 1 : 2,
                        send_time: isImmediately
                            ? '2000-01-01T00:00:00+09:00'
                            : (0, moment_1.default)(`${startDate} ${startTime}`).format('YYYY-MM-DDTHH:mm:ssZ'),
                    },
                });
                if (response.result.skip > 0) {
                    alert(t('sendSMS.sendSkip', { skip: response.result.skip }));
                }
                APP.eventManager.publish('UPDATE_SEND_SMS');
                refetchList();
                cleanup();
                if (isMobile) {
                    dispatch((0, action_1.updateMenu)(undefined, { menu: 'sendSMS', detail: 'list' }));
                }
                else {
                    APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                        menuDetail: 'list',
                        id: undefined,
                    });
                }
            }
            catch (error) {
                console.error('Failed to post modifySendSMS:', error);
                alert(error);
            }
            finally {
                APP.eventManager.publish('SHOW_LOADING', false);
                closePopup();
            }
        }
        else {
            try {
                APP.eventManager.publish('SHOW_LOADING', true);
                const response = await registSendSMSMutation.mutateAsync({
                    title: title,
                    content: message,
                    members_only: isOnlyStudentMember,
                    phone_number: isFixNumber ? '' : directNumber,
                    receivers: format,
                    receivers_type: memberSetting === 'everyStudent' ? 0 : memberSetting === 'oneByOne' ? 1 : 2,
                    send_time: isImmediately
                        ? null
                        : (0, moment_1.default)(`${startDate} ${startTime}`).format('YYYY-MM-DDTHH:mm:ssZ'),
                });
                if (response.result.skip > 0) {
                    alert(t('sendSMS.sendSkip', { skip: response.result.skip }));
                }
                APP.eventManager.publish('UPDATE_SEND_SMS');
                setReceiverMemberList([]);
                cleanup();
                if (isMobile) {
                    dispatch((0, action_1.updateMenu)(undefined, { menu: 'sendSMS', detail: 'list' }));
                }
                else {
                    APP.eventManager.publish('UPDATE_DETAIL_MENU', {
                        menuDetail: 'list',
                        id: undefined,
                    });
                }
            }
            catch (error) {
                console.error('Failed to post registSendSMS:', error);
                alert(error);
            }
            finally {
                APP.eventManager.publish('SHOW_LOADING', false);
                closePopup();
            }
        }
    };
    const handlerOpenMemberList = () => {
        setOpenMemberList(!openMemberList);
    };
    const handlerPreviousPage = () => {
        APP.eventManager.publish('UPDATE_DETAIL_MENU', {
            menuDetail: 'list',
            id: undefined,
        });
    };
    const renderTitleInfo = (react_1.default.createElement(layout_1.DetailTitleInfo, { title: t('sendSMS.sendSMS'), previousPage: handlerPreviousPage }));
    const quillRef = (0, react_1.useRef)(null);
    const [lastCursorPosition, setLastCursorPosition] = (0, react_1.useState)(0);
    const handleLastCursorPosition = (position) => {
        setLastCursorPosition(position);
    };
    const addSubstituteWord = (word) => {
        if (!quillRef.current)
            return;
        const quill = quillRef.current;
        quill.insertText(lastCursorPosition, `#{${word}}`, { color: '#8268d9' });
        quill.setSelection(lastCursorPosition + `#{${word}}`.length);
        quill.format('color', 'black');
        setLastCursorPosition(lastCursorPosition + `#{${word}}`.length);
    };
    return (react_1.default.createElement(SendSMSContentStyled, { className: "send-sms-content wrapper-padding", "$isDesktop": isDesktop, "$isTablet": isTablet, "$isMobile": isMobile },
        isDesktop && renderTitleInfo,
        react_1.default.createElement("div", { className: "sms-wrap" },
            !isMobile && (react_1.default.createElement("div", { className: "sms-preview" },
                react_1.default.createElement("div", { className: "preview-wrap", style: { flex: '1' } },
                    react_1.default.createElement("p", { className: "overText message-text" }, t('sendSMS.messagePreview')),
                    react_1.default.createElement("div", { ref: previewDivRef, className: "sms-preview-content" })))),
            react_1.default.createElement("div", { className: "sms-regist" },
                isMobile && (react_1.default.createElement(common_1.Button, { className: "btn-recipient-setting", text: `수신자 (${receiverMemberList?.length > 0
                        ? receiverMemberList.length.toString().padStart(2, '0')
                        : '00'})명`, option: {
                        buttonAfterIcon: {
                            show: true,
                            name: isMobile ? 'plus' : 'twoarrow',
                            size: isDesktop ? 22 : 12,
                            color: Colors_1.Colors.tur,
                        },
                    }, onClick: handlerOpenMemberList })),
                react_1.default.createElement("div", { className: "sms-setting-content" },
                    react_1.default.createElement("div", { className: "sms-setting" },
                        react_1.default.createElement("div", { className: "sms-type" },
                            react_1.default.createElement("p", { className: "overText" }, t('sendSMS.sendType')),
                            react_1.default.createElement(common_1.CheckBox, { iconSize: isDesktop ? 24 : 20, isRadioButton: true, list: selectedId ? isNormal ? constant_1.SMS_TYPE_CHECK_NORMAL : constant_1.SMS_TYPE_CHECK_SUBSTITUTE : constant_1.SMS_TYPE_CHECK_LIST, defaultCheckId: isNormal ? 'normal' : 'substitute', handlerCheck: (id, checked) => {
                                    if (selectedId !== "")
                                        return;
                                    setIsNormal(id === 'normal');
                                } })),
                        react_1.default.createElement("div", { className: "sms-time-wrap" },
                            react_1.default.createElement("div", { className: "sms-time" },
                                react_1.default.createElement("p", { className: "overText" }, t('sendSMS.sendDate')),
                                react_1.default.createElement("div", { className: "sms-time", style: {
                                        flexDirection: !isMobile ? 'row' : 'column',
                                        alignItems: !isMobile ? 'center' : 'flex-start'
                                    } },
                                    react_1.default.createElement(common_1.CheckBox, { iconSize: isDesktop ? 24 : 20, isRadioButton: true, list: constant_1.DATE_CHECK_LIST, defaultCheckId: isImmediately ? 'now' : 'reservation', handlerCheck: (id, checked) => {
                                            setIsImmediately(id === 'now');
                                        } }),
                                    !isImmediately && (react_1.default.createElement("div", { className: "sms-time" },
                                        react_1.default.createElement("div", { className: `fext-field ${isMobile ? 'mobile-date-wrap' : ''}` },
                                            react_1.default.createElement(common_1.InputElement, { type: "date", className: "input_send", value: startDate, onChange: setStartDate, min: now.format('YYYY-MM-DD') })),
                                        react_1.default.createElement("div", { className: `fext-field ${isMobile ? 'mobile-date-wrap' : ''}` },
                                            react_1.default.createElement(common_1.InputElement, { type: "time", className: "input_send", value: startTime, onChange: setStartTime })))))))),
                    react_1.default.createElement("div", { className: "send-wrap" },
                        react_1.default.createElement("p", { className: "overText message-text" }, t('sendSMS.messageTitle')),
                        react_1.default.createElement(common_1.InputElement, { className: "sms-title", type: "text", textarea: true, value: title, onChange: value => {
                                if (value.length <= 20) {
                                    setTitle(value);
                                }
                            }, placeholder: t('sendSMS.messageTitle') })),
                    react_1.default.createElement("div", { className: "send-wrap", style: isMobile ? { height: '100%', minHeight: '147px' } : {} },
                        react_1.default.createElement("div", { className: "content-info" },
                            react_1.default.createElement("p", { className: "overText message-text" }, t('sendSMS.messageContent')),
                            react_1.default.createElement("p", { className: "message-length" }, messageLength)),
                        react_1.default.createElement("div", { className: "sms-content-wrap" },
                            react_1.default.createElement(Editor, { className: "sms-content", ref: quillRef, defaultValue: defaultMessage, onSelectionChange: handleLastCursorPosition, onTextChange: value => setMessage(value.replace(/\n$/, '')), placeholder: t('sendSMS.messageContent') }))),
                    !isNormal && (react_1.default.createElement("div", { className: "sms-substitute-wrap" },
                        react_1.default.createElement("p", { className: "overText message-text" }, t('sendSMS.substituteCharacter')),
                        react_1.default.createElement("div", { className: "substitute-list" }, exports.substitutes.map((item, index) => (react_1.default.createElement(common_1.Button, { key: index, className: "btn_line_tur substitute-word", text: item, onClick: () => addSubstituteWord(item), style: { color: Colors_1.Colors.tur } }))))))),
                !isMobile && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", { className: "divider" }),
                    react_1.default.createElement(MemberList_1.MemberList, { isNormal: isNormal, substitutes: exports.substitutes, receiverMemberList: receiverMemberList, setReceiverMemberList: setReceiverMemberList, memberSetting: memberSetting, originalStudentData: originalStudentData, everyStudentData: everyStudentData, oneByOneData: oneByOneData, excelUploadData: excelUploadData, setMemberSetting: setMemberSetting, setOriginalStudentData: setOriginalStudentData, setEveryStudentData: setEveryStudentData, setOneByOneData: setOneByOneData, setExcelUploadData: setExcelUploadData, isOnlyStudent: isOnlyStudentMember, setIsOnlyStudent: setIsOnlyStudentMember }))),
                isMobile ? (react_1.default.createElement("div", { className: "btn-container" },
                    react_1.default.createElement(common_1.Button, { className: `btn_default ${isMobile ? 'mobile-full' : 'xmd'}`, text: "\uBCF4\uB0B4\uAE30", onClick: handlerSend }))) : (react_1.default.createElement("div", { className: "btn-container", style: { justifyContent: 'space-between' } },
                    react_1.default.createElement(common_1.Button, { className: `btn_line_light_grey ${isMobile ? 'mobile-full' : 'xmd'}`, text: t('sendSMS.preview'), onClick: handlerPreview }),
                    react_1.default.createElement("div", { className: "btn-container" },
                        react_1.default.createElement(common_1.Button, { className: `btn_white ${isMobile ? 'mobile-full' : 'xmd'}`, text: t('common.cancel'), onClick: handlerCancel }),
                        react_1.default.createElement(common_1.Button, { className: `btn_default ${isMobile ? 'mobile-full' : 'xmd'}`, text: "\uBCF4\uB0B4\uAE30", onClick: handlerSend })))))),
        isMobile && (react_1.default.createElement("div", { className: "popup", style: { display: openMemberList ? 'flex' : 'none' } },
            react_1.default.createElement("div", { className: "popup-wrapper", style: { width: "90%" } },
                react_1.default.createElement("div", { className: "popup-body" },
                    react_1.default.createElement("div", { className: "popup-header-member-list" },
                        react_1.default.createElement("p", { className: "overText" }, t('sendSMS.selectMember')),
                        react_1.default.createElement("div", { onClick: () => setOpenMemberList(!openMemberList), style: { cursor: 'pointer' } },
                            react_1.default.createElement(common_1.Icon, { icon: "close", size: 24, fill: Colors_1.Colors.light_grey }))),
                    react_1.default.createElement("div", { className: "popup-content" },
                        react_1.default.createElement(MemberList_1.MemberList, { isNormal: isNormal, substitutes: exports.substitutes, receiverMemberList: receiverMemberList, setReceiverMemberList: setReceiverMemberList, memberSetting: memberSetting, originalStudentData: originalStudentData, everyStudentData: everyStudentData, oneByOneData: oneByOneData, excelUploadData: excelUploadData, setMemberSetting: setMemberSetting, setOriginalStudentData: setOriginalStudentData, setEveryStudentData: setEveryStudentData, setOneByOneData: setOneByOneData, setExcelUploadData: setExcelUploadData, isOnlyStudent: isOnlyStudentMember, setIsOnlyStudent: setIsOnlyStudentMember }))))))));
});
// 커스텀 에디터
const Editor = (0, react_1.forwardRef)(({ defaultValue, onTextChange, onSelectionChange, placeholder }, ref) => {
    const containerRef = (0, react_1.useRef)(null);
    const onTextChangeRef = (0, react_1.useRef)(onTextChange);
    const onSelectionChangeRef = (0, react_1.useRef)(onSelectionChange);
    const getByteLength = (text) => {
        return [...text].reduce((bytes, char) => bytes + (char.charCodeAt(0) <= 127 ? 1 : 2), 0);
    };
    (0, react_1.useLayoutEffect)(() => {
        onTextChangeRef.current = onTextChange;
        onSelectionChangeRef.current = onSelectionChange;
    });
    (0, react_1.useEffect)(() => {
        const container = containerRef.current;
        const editorContainer = container.appendChild(document.createElement('div'));
        const quill = new react_quill_1.Quill(editorContainer, {
            theme: 'bubble',
            modules: {
                toolbar: false,
                keyboard: {
                    bindings: {
                        customBackspace: {
                            key: 'backspace',
                            handler: function (range, context) {
                                const text = quill.getText();
                                const cursorIndex = range.index;
                                const regex = /#{[^}]+}/g;
                                let match;
                                while ((match = regex.exec(text)) !== null) {
                                    const startIdx = match.index;
                                    const endIdx = startIdx + match[0].length;
                                    if (cursorIndex > startIdx && cursorIndex <= endIdx) {
                                        quill.deleteText(startIdx, endIdx - startIdx);
                                        setTimeout(() => quill.setSelection(startIdx), 0);
                                        return false;
                                    }
                                }
                                return true;
                            },
                        },
                    },
                },
            },
            placeholder: placeholder || '',
        });
        quill.root.setAttribute('spellcheck', 'false');
        ref.current = quill;
        quill.on(react_quill_1.Quill.events.SELECTION_CHANGE, (range) => {
            if (!range)
                return;
            onSelectionChangeRef.current?.(range.index);
            const text = quill.getText(0, range.index);
            const regex = /#{[^}]+}/g;
            let match;
            let isAfterSubstituteWord = false;
            while ((match = regex.exec(text)) !== null) {
                const startIdx = match.index;
                const endIdx = startIdx + match[0].length;
                if (range.index === endIdx) {
                    isAfterSubstituteWord = true;
                    break;
                }
            }
            if (isAfterSubstituteWord) {
                quill.format('color', 'black');
            }
        });
        quill.on(react_quill_1.Quill.events.TEXT_CHANGE, (delta, oldContents, source) => {
            const selection = quill.getSelection();
            if (selection) {
                onSelectionChangeRef.current?.(selection.index);
            }
            const text = quill.getText();
            const byteLength = getByteLength(text);
            if (byteLength > 1001 && source === 'user') {
                quill.setContents(oldContents);
                if (selection) {
                    quill.setSelection(selection);
                }
            }
            else {
                onTextChangeRef.current?.(text);
            }
        });
        if (defaultValue !== '') {
            quill.setText(defaultValue);
            const regex = /#{[^}]+}/g;
            let match;
            while ((match = regex.exec(defaultValue)) !== null) {
                quill.formatText(match.index, match[0].length, { color: '#8268d9' });
            }
        }
        return () => {
            ref.current = null;
            container.innerHTML = '';
        };
    }, [ref, placeholder, defaultValue]);
    return react_1.default.createElement("div", { className: "sms-content", ref: containerRef });
});
Editor.displayName = 'Editor';
